export default {
  namespaced: true,
  state: {
    id: '', // 商户id
    loginId: '', // 账户id
    loginName: '',
    accountId: '', // 员工/机构的登录账号名称
    dzdPermission: false,
    userInfo: {},
    useMemberSystem: false, // 会员功能开通之后，是否使用过
    labaFactoryList: [], // 云喇叭厂商
    departmentList: [], // 所属部门
    zeroTaxFlags: [
      { id: '-1', name: '非零税率' },
      { id: '0', name: '出口零税' },
      { id: '1', name: '免税' },
      { id: '2', name: '不征税' },
      { id: '3', name: '普通零税率' }
    ],
    // 分账状态
    divideOrderStates: [
      { id: '', name: '全部' },
      { id: 0, name: '待分账' },
      { id: 1, name: '分账中' },
      { id: 2, name: '分账成功' },
      { id: 3, name: '分账失败' }
    ],
    // 分账状态
    divideOrderFinishStates: [
      { id: '', name: '全部' },
      { id: 0, name: '待分账完结' },
      { id: 1, name: '分账完结中' },
      { id: 2, name: '分账完结成功' },
      { id: 3, name: '分账完结失败' },
      { id: 4, name: '不执行分账完结' }
    ],
    // 分账-支付方式
    payTypes: [
      { id: '', name: '全部' },
      { id: 'ZFB', name: '支付宝' },
      { id: 'WX', name: '微信' },
      { id: 'UNION_PAY', name: '银联付款' },
      { id: 'ZFBHB', name: '支付宝花呗' },
      { id: 'HYC', name: '会员卡' },
      { id: 'YLZF', name: '银联支付' },
      { id: 'YZF', name: '翼支付' },
      { id: 'LZF', name: '龙支付' }
    ],
    // 分账-支付状态
    payStatus: [
      { id: '', name: '全部' },
      { id: 'SUCCESS', name: '成功' },
      { id: 'FAILED', name: '失败' },
      { id: 'NOT_PAID', name: '待付款' },
      { id: 'WITHDRAWN', name: '已经撤销' },
      { id: 'REFUND', name: '已转入退款' },
      { id: 'PART_REFUND', name: '已转入部分退款' },
      { id: 'REFUND_COMPLETE', name: '退款完成' }
    ],
    // 分账-支付类型
    orderTypes: [
      { id: null, name: '全部' },
      { id: 'AGG', name: '聚合码' },
      { id: 'COLLECTION', name: '收款码' },
      { id: 'SCANNEDPAY', name: '被扫' }
    ],
    orderBalanceType: [
      { id: '5', name: '插件' },
      { id: '4', name: '码牌' }
    ],
    divideTypes: [
      { id: 1, name: '码牌分账' },
      { id: 2, name: '系统分账' }
    ]
    // 设备类型
    // upMccs: [
    //   { id: '2', name: 'POS' },
    //   { id: '4', name: '码牌' },
    //   { id: '5', name: '插件' }
    // ]
  },
  mutations: {
    setData (state, data) {
      const info = data.loginUserVo.merchantLoginInfoVo
      const loginType = window.localStorage.getItem('loginType')
      state.id = info.merchantId
      if (loginType === 'orgUser') {
        state.loginId = window.localStorage.getItem('loginOrgUserId')
        state.loginName = info.orgName
      } else if (loginType === 'orgAccount') {
        state.loginId = window.localStorage.getItem('orgId')
        state.loginName = info.orgUserName
      } else if (loginType === 'account') {
        state.loginId = window.localStorage.getItem('loginMerchantId')
        state.loginName = data.merchantName
      } else if (loginType === 'assistant') {
        state.loginId = info.account
        state.loginName = info.userName
        state.accountId = info.userId
      }
      state.dzdPermission = data.permissionIsEnable
    },
    getUserInfo (state, userInfo) {
      console.log('userInfo', userInfo)
      state.userInfo = userInfo
    },
    updateUseMemberSystem (state, data) {
      state.useMemberSystem = data
    },
    getLabaFactoryList (state, data) {
      state.labaFactoryList = data.map(item => ({
        id: item.deviceFactory,
        name: item.deviceName
      }))
    },
    updateDepartmentList (state, data) {
      state.departmentList = data
      console.log('8888: ', state.departmentList)
    }
  }
}
